import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import { accountsAPI } from 'services/accounts';

import { Creators as RolesActions, Types as RolesTypes } from 'store/ducks/roles';

function* getRoleRequest(action) {
  try {
    const { id } = action.payload;
    const url = `auth/roles/${id}`;
    const response = yield call(accountsAPI.get, url);

    yield put(RolesActions.getRoleSuccess(response.data));
  } catch (error) {
    yield put(RolesActions.getRoleFailure());
  }
}

function* getRolesRequest(action) {
  try {
    const { page } = action.payload;
    const url = `auth/roles?page=${page}&per=25`;
    const response = yield call(accountsAPI.get, url);

    yield put(RolesActions.getRolesSuccess(response.data));
  } catch (error) {
    yield put(RolesActions.getRolesFailure());
  }
}

function* createRoleRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'auth/roles';
    yield call(accountsAPI.post, url, data);

    yield put(push('/configs/roles'));
    yield call(swal, 'Adicionado', 'Nova função adicionada', 'success');
    yield put(RolesActions.createRoleSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar a função.', 'error');
    yield put(RolesActions.createRoleFailure());
  }
}

function* updateRoleRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `auth/roles/${id}`;
    yield call(accountsAPI.put, url, data);

    yield put(push('/configs/roles'));
    yield call(swal, 'Atualizado', 'Função atualizada', 'success');
    yield put(RolesActions.updateRoleSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar a função.', 'error');
    yield put(RolesActions.updateRoleFailure());
  }
}

export default function* sagaRoles() {
  yield takeLatest(RolesTypes.GET_REQUEST, getRoleRequest);
  yield takeLatest(RolesTypes.GET_LIST_REQUEST, getRolesRequest);
  yield takeLatest(RolesTypes.CREATE_REQUEST, createRoleRequest);
  yield takeLatest(RolesTypes.UPDATE_REQUEST, updateRoleRequest);
}
